import { Component, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ApiserviceService } from "../../../../../../src/app/apiservice.service";
import { NotificationService } from "../../../../../../src/app/admin/services/notification.service";

@Component({
  selector: 'app-add-edit-master-value',
  templateUrl: './add-edit-master-value.component.html',
  styleUrls: ['./add-edit-master-value.component.scss']
})
export class AddEditMasterValueComponent {
  isLoading: boolean = false
 createMasterValueForm!: FormGroup;
  selected_lang = 1;
  language_list = [
    { value: 1, viewValue: "English" },
    { value: 2, viewValue: "Arabic" }
  ];
  masterDataList: any;
  optionMasterData: any;
  dialogTitle: string = "Create Master Value";
  dialogSubTitle: string = "Fill in the details below to add a new master value record";
   isEdit: boolean = false;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddEditMasterValueComponent>,
    private api: ApiserviceService,
     private notify: NotificationService, // Injecting notification service for user notification
     @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
      if (this.data) {
      this.masterDataList = this.data.MasterData;
            // Suppose this.api.language holds the current language ID
      const currentLangId = this.api.language;

      // Convert masters into dropdown options
      this.optionMasterData = this.masterDataList.map((master: any) => ({
        value: master.id,
        viewValue: master.label?.[currentLangId] || master.name || 'Unnamed'
      }));

      console.log('Dropdown Options:', this.optionMasterData);
    }
  }
//    Validators.pattern(/^[A-Za-z0-9_]*$/)
  ngOnInit(): void {
  // Initialize form
  this.createMasterValueForm = this.fb.group({
    masterValueName: ["", [
      Validators.required,
      Validators.maxLength(64)
    ]],
    masterValueLabels: this.fb.array([]), // start empty, we'll populate below
    parentMaster: ["", Validators.required],
    status: [1, Validators.required], // Default to active (1)
  });

  // If edit, patch data
  if (this.data?.type === 'edit' && this.data?.selectedValue) {
    const selected = this.data.selectedValue;
    this.isEdit = true;
    this.dialogSubTitle = "Update the details of the master value record";
    this.dialogTitle = "Update Master Value";

    // 1️⃣ Patch simple fields
    this.createMasterValueForm.patchValue({
      masterValueName: selected.mv_name,
      parentMaster: selected.master_id,
      status: selected.status || 1, // Patch current status for edit
    });

    // 2️⃣ Patch FormArray for labels
    const labelsArray = this.createMasterValueForm.get('masterValueLabels') as FormArray;
    labelsArray.clear(); // clear default empty row

    if (selected.mv_label && typeof selected.mv_label === 'object') {
      Object.entries(selected.mv_label).forEach(([langId, labelValue]) => {
        labelsArray.push(this.fb.group({
          language: Number(langId),
          label: labelValue as string,
        }));
      });
    }
  } else {
    // If add, just add one row for first language
    this.addLabelRow();
  }
}


  // Create a single label group (language + label)
  createLabelGroup(): FormGroup {
    return this.fb.group({
      language: ["", Validators.required],
      label: ["", [Validators.required, Validators.maxLength(64)]],
    });
  }

  // Get form array
  get masterValueLabels(): FormArray {
    return this.createMasterValueForm.get("masterValueLabels") as FormArray;
  }

  // Add new label row
  addLabelRow(): void {
    this.masterValueLabels.push(this.createLabelGroup());
  }

  // Remove specific row
  removeLabelRow(index: number): void {
    if (this.masterValueLabels.length > 1) {
      this.masterValueLabels.removeAt(index);
    }
  }

  // Get status as boolean for checked
  get isStatusActive(): boolean {
    return this.createMasterValueForm.get('status')?.value === 1;
  }

  // Handle status toggle change
  onStatusChange(checked: boolean): void {
    this.createMasterValueForm.get('status')?.setValue(checked ? 1 : 0);
  }

  onSubmit(): void {
  if (this.createMasterValueForm.invalid) {
    this.createMasterValueForm.markAllAsTouched();
    return;
  }
      // English mandatory check
const labels = this.masterValueLabels.value;
const hasEnglish = labels.some(l => Number(l.language) === 1);
const hasNonEnglish = labels.some(l => Number(l.language) !== 1);
// Duplicate language check
const languages = labels.map(l => Number(l.language));
const duplicates = languages.filter((item, index) => languages.indexOf(item) !== index);

if (hasNonEnglish && !hasEnglish) {
  this.notify.notify("English label is required when using other languages.", "warn");
  return;
}

if (duplicates.length > 0) {
  this.notify.notify("Same language cannot be added multiple times.", "warn");
  return;
}

  if (this.data?.type === 'edit') {
    this.updateMasterValue();
  } else {
    this.createNewMasterValue();
  }
}

  // Submit form
  createNewMasterValue(): void {
      if (this.createMasterValueForm.invalid) {
      this.createMasterValueForm.markAllAsTouched();
      return;
    }
    const url = "master-values";
    const formValue = this.createMasterValueForm.value;
    const payload = {
      master_value_name: formValue.masterValueName?.trim(),
      master_value_label: formValue.masterValueLabels.reduce((acc, item) => {
        acc[item.language] = item.label;
        return acc;
      }, {} as { [key: number]: string }),
      status: 1,
      added_by: this.api.user_id,
      master_id: formValue.parentMaster,
      image_url:''
    };
this.isLoading = true;
    this.api.postGmsData(url, payload).subscribe({
      next: (res) => {
        this.isLoading = false
        this.createMasterValueForm.reset();
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false
        console.error('Error creating master', err);
      }
    });
  }

   updateMasterValue(): void {
      if (this.createMasterValueForm.invalid) {
      this.createMasterValueForm.markAllAsTouched();
      return;
    }
    const url = "master-values";
    const formValue = this.createMasterValueForm.value;
    const payload = {
      master_value_name: formValue.masterValueName,
      master_value_id:this.data?.selectedValue?.id,
      master_value_label: formValue.masterValueLabels.reduce((acc, item) => {
        acc[item.language] = item.label;
        return acc;
      }, {} as { [key: number]: string }),
      status: formValue.status, // Now always number 0/1 due to onStatusChange
      added_by: this.api.user_id,
      master_id: formValue.parentMaster,
      image_url:''
    };
    this.isLoading = true;
    this.api.patchGmsData(url, payload).subscribe({
      next: (res) => {
        this.isLoading = false
        this.createMasterValueForm.reset();
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false
        console.error('Error creating master', err);
      }
    });
  }

  // Cancel / Reset
  onCancel(): void {
    this.dialogRef.close(); // ✅ closes the popup
  }

  // Helper to check errors easily in template
  hasError(control: any, errorType: string): boolean {
    return control.hasError(errorType) && (control.dirty || control.touched);
  }
}
